export default {
  isAvailableAsync: async () => true,
  getItemAsync: async (key: string) => localStorage.getItem(key),
  setItemAsync: async (key: string, value: string) => {
    localStorage.setItem(key, value)
  },
  deleteItemAsync: async (key: string) => {
    localStorage.removeItem(key)
  },
}
